import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ProductSidebar.css';

const PRODUCTS = [
  { icon: '🏆', label: 'Interview Assistant', path: '/InterviewAssistant' },
  { icon: '🔮', label: 'Mock AI Interview',   path: '/mockInterview' },
  { icon: '📄', label: 'Resume Builder',      path: '/BuildResume' },
  { icon: '🛡️', label: 'Cover Letter',        path: '/CoverLetter' },
  { icon: '⭐', label: 'ATS Check',           path: '/ATSCheck' },
  { icon: '💎', label: 'Interview Questions', path: '/InterviewQuestions' },
  { icon: '🔗', label: 'LinkedIn Optimizer',  path: '/LinkedInOptimizer' },
  { icon: '📨', label: 'Auto Apply',          path: '/AutoJobApply' },
  { icon: '🎓', label: 'AI Certification',   path: '/certification' },
  { icon: '🌐', label: 'Portfolio Builder',  path: '/portfolio' },
];

const ProductSidebar = ({ user, setShowAuthModal }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (path) => {
    if (!user) {
      setShowAuthModal(true);
    } else {
      navigate(path);
      window.scrollTo(0, 0);
    }
    setOpen(false);
  };

  return (
    <>
      <div className={`product-sidebar ${open ? 'open' : ''}`}>
        <button className="sidebar-toggle" onClick={() => setOpen(!open)}>
          {open ? '✕' : '⚡'}
        </button>
        <div className="sidebar-inner">
          <div className="sidebar-logo">⚡ Launchpad</div>
          {PRODUCTS.map((item) => (
            <div
              key={item.path}
              className={`sidebar-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleClick(item.path)}
            >
              <span className="sidebar-item-icon">{item.icon}</span>
              <span className="sidebar-item-label">{item.label}</span>
            </div>
          ))}
          <p className="sidebar-footer">Powered by TERVIEW.AI</p>
        </div>
      </div>
      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)} />}
    </>
  );
};

export default ProductSidebar;